import { render, staticRenderFns } from "./ModalPersonDocument.vue?vue&type=template&id=e1e635d8&scoped=true&"
import script from "./ModalPersonDocument.vue?vue&type=script&lang=js&"
export * from "./ModalPersonDocument.vue?vue&type=script&lang=js&"
import style0 from "./ModalPersonDocument.vue?vue&type=style&index=0&id=e1e635d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e635d8",
  null
  
)

export default component.exports